// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__e_rBA","disclaimer":"styles_disclaimer__qFBlN","tcs":"styles_tcs__97XSL"};